import { REFRESH_TOKEN_SUCCESS } from 'stash/actions/api/auth';
import { POST_USER_SUCCESS } from 'stash/actions/api/user';
import { formatAccessToken } from 'stash/utils';

const api_key = (state = {}, action) => {
  switch (action.type) {
    case POST_USER_SUCCESS:
      return {
        ...state,
        ...action.response.api_key,
        uuid: action.response.user.uuid,
      };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        access_token: formatAccessToken(action.response.access_token),
        refresh_token: action.response.refresh_token,
      };
    default:
      return state;
  }
};

export default api_key;
